import { render } from "./PublicTermsModal.vue?vue&type=template&id=1c7d2780&scoped=true"
import script from "./PublicTermsModal.vue?vue&type=script&lang=js"
export * from "./PublicTermsModal.vue?vue&type=script&lang=js"

import "./PublicTermsModal.vue?vue&type=style&index=0&id=1c7d2780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7d2780"]])

export default __exports__